/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetBasicUserResponse,
  RefreshTokenResponse,
  RequestTokenRequest,
  RenewRefreshTokenRequest,
  DestroyAuthRefreshTokenResponse,
  LoginResponse,
  LoginRequest,
  SignUpRequest,
  SetupPasswordRequest,
  OtpVerifyDTO,
  ObtainOTPResponse,
  ObtainOtpRequest,
  HelloRequest,
  MigrateRequest,
  ExternalLoginResponse,
  ExternalLoginRequest,
  ExternalSignupResponse,
  ExternalSignupRequest
} from './schema'



export const utxAuthGetInfo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBasicUserResponse>> => {
    return axios.get(
      `/auth`,options
    );
  }


export const getUtxAuthGetInfoQueryKey = () => [`/auth`];

    
export type UtxAuthGetInfoQueryResult = NonNullable<Awaited<ReturnType<typeof utxAuthGetInfo>>>
export type UtxAuthGetInfoQueryError = AxiosError<unknown>

export const useUtxAuthGetInfo = <TData = Awaited<ReturnType<typeof utxAuthGetInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxAuthGetInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxAuthGetInfoQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxAuthGetInfo>>> = ({ signal }) => utxAuthGetInfo({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxAuthGetInfo>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Refresh jwt token to extend the expiry time
 */
export const utxAuthRefreshToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RefreshTokenResponse>> => {
    return axios.get(
      `/auth/jwt/refresh`,options
    );
  }


export const getUtxAuthRefreshTokenQueryKey = () => [`/auth/jwt/refresh`];

    
export type UtxAuthRefreshTokenQueryResult = NonNullable<Awaited<ReturnType<typeof utxAuthRefreshToken>>>
export type UtxAuthRefreshTokenQueryError = AxiosError<unknown>

export const useUtxAuthRefreshToken = <TData = Awaited<ReturnType<typeof utxAuthRefreshToken>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxAuthRefreshToken>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxAuthRefreshTokenQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxAuthRefreshToken>>> = ({ signal }) => utxAuthRefreshToken({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxAuthRefreshToken>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Request new access token from refresh token
 */
export const utxAuthGetAccessTokenByRefreshToken = (
    requestTokenRequest: RequestTokenRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RefreshTokenResponse>> => {
    return axios.post(
      `/auth/jwt/refresh`,
      requestTokenRequest,options
    );
  }



    export type UtxAuthGetAccessTokenByRefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthGetAccessTokenByRefreshToken>>>
    export type UtxAuthGetAccessTokenByRefreshTokenMutationBody = RequestTokenRequest
    export type UtxAuthGetAccessTokenByRefreshTokenMutationError = AxiosError<unknown>

    export const useUtxAuthGetAccessTokenByRefreshToken = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthGetAccessTokenByRefreshToken>>, TError,{data: RequestTokenRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthGetAccessTokenByRefreshToken>>, {data: RequestTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthGetAccessTokenByRefreshToken(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthGetAccessTokenByRefreshToken>>, TError, {data: RequestTokenRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Request new access token from mobile token
 */
export const utxAuthGetAccessTokenByMobileToken = (
    requestTokenRequest: RequestTokenRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RefreshTokenResponse>> => {
    return axios.post(
      `/auth/jwt/mobile/refresh`,
      requestTokenRequest,options
    );
  }



    export type UtxAuthGetAccessTokenByMobileTokenMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthGetAccessTokenByMobileToken>>>
    export type UtxAuthGetAccessTokenByMobileTokenMutationBody = RequestTokenRequest
    export type UtxAuthGetAccessTokenByMobileTokenMutationError = AxiosError<unknown>

    export const useUtxAuthGetAccessTokenByMobileToken = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthGetAccessTokenByMobileToken>>, TError,{data: RequestTokenRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthGetAccessTokenByMobileToken>>, {data: RequestTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthGetAccessTokenByMobileToken(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthGetAccessTokenByMobileToken>>, TError, {data: RequestTokenRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Renew refresh token
 */
export const utxAuthRenewRefreshToken = (
    renewRefreshTokenRequest: RenewRefreshTokenRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RefreshTokenResponse>> => {
    return axios.post(
      `/auth/jwt/refresh/renew`,
      renewRefreshTokenRequest,options
    );
  }



    export type UtxAuthRenewRefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthRenewRefreshToken>>>
    export type UtxAuthRenewRefreshTokenMutationBody = RenewRefreshTokenRequest
    export type UtxAuthRenewRefreshTokenMutationError = AxiosError<unknown>

    export const useUtxAuthRenewRefreshToken = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthRenewRefreshToken>>, TError,{data: RenewRefreshTokenRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthRenewRefreshToken>>, {data: RenewRefreshTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthRenewRefreshToken(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthRenewRefreshToken>>, TError, {data: RenewRefreshTokenRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Destroy refresh token
 */
export const utxAuthDestroyRefreshToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DestroyAuthRefreshTokenResponse>> => {
    return axios.post(
      `/auth/jwt/destroy`,undefined,options
    );
  }



    export type UtxAuthDestroyRefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthDestroyRefreshToken>>>
    
    export type UtxAuthDestroyRefreshTokenMutationError = AxiosError<unknown>

    export const useUtxAuthDestroyRefreshToken = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthDestroyRefreshToken>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthDestroyRefreshToken>>, TVariables> = () => {
          

          return  utxAuthDestroyRefreshToken(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthDestroyRefreshToken>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    export const utxAuthLogin = (
    loginRequest: LoginRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.post(
      `/auth/login`,
      loginRequest,options
    );
  }



    export type UtxAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthLogin>>>
    export type UtxAuthLoginMutationBody = LoginRequest
    export type UtxAuthLoginMutationError = AxiosError<unknown>

    export const useUtxAuthLogin = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthLogin>>, TError,{data: LoginRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthLogin>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthLogin(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthLogin>>, TError, {data: LoginRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxAuthSignup = (
    signUpRequest: SignUpRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/signup`,
      signUpRequest,options
    );
  }



    export type UtxAuthSignupMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthSignup>>>
    export type UtxAuthSignupMutationBody = SignUpRequest
    export type UtxAuthSignupMutationError = AxiosError<unknown>

    export const useUtxAuthSignup = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthSignup>>, TError,{data: SignUpRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthSignup>>, {data: SignUpRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthSignup(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthSignup>>, TError, {data: SignUpRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxAuthSetupPassword = (
    setupPasswordRequest: SetupPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/setup-password`,
      setupPasswordRequest,options
    );
  }



    export type UtxAuthSetupPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthSetupPassword>>>
    export type UtxAuthSetupPasswordMutationBody = SetupPasswordRequest
    export type UtxAuthSetupPasswordMutationError = AxiosError<unknown>

    export const useUtxAuthSetupPassword = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthSetupPassword>>, TError,{data: SetupPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthSetupPassword>>, {data: SetupPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthSetupPassword(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthSetupPassword>>, TError, {data: SetupPasswordRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Verify Tfa TOTP Login token
 */
export const utxAuthVerifyTfaTOtpLoginToken = (
    otpVerifyDTO: OtpVerifyDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/tfa-totp-login`,
      otpVerifyDTO,options
    );
  }



    export type UtxAuthVerifyTfaTOtpLoginTokenMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthVerifyTfaTOtpLoginToken>>>
    export type UtxAuthVerifyTfaTOtpLoginTokenMutationBody = OtpVerifyDTO
    export type UtxAuthVerifyTfaTOtpLoginTokenMutationError = AxiosError<unknown>

    export const useUtxAuthVerifyTfaTOtpLoginToken = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthVerifyTfaTOtpLoginToken>>, TError,{data: OtpVerifyDTO}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthVerifyTfaTOtpLoginToken>>, {data: OtpVerifyDTO}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthVerifyTfaTOtpLoginToken(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthVerifyTfaTOtpLoginToken>>, TError, {data: OtpVerifyDTO}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Verify Tfa Sms Otp Login token
 */
export const utxAuthVerifyTfaSmsOtpLoginToken = (
    otpVerifyDTO: OtpVerifyDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/tfa-sms-otp-login`,
      otpVerifyDTO,options
    );
  }



    export type UtxAuthVerifyTfaSmsOtpLoginTokenMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthVerifyTfaSmsOtpLoginToken>>>
    export type UtxAuthVerifyTfaSmsOtpLoginTokenMutationBody = OtpVerifyDTO
    export type UtxAuthVerifyTfaSmsOtpLoginTokenMutationError = AxiosError<unknown>

    export const useUtxAuthVerifyTfaSmsOtpLoginToken = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthVerifyTfaSmsOtpLoginToken>>, TError,{data: OtpVerifyDTO}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthVerifyTfaSmsOtpLoginToken>>, {data: OtpVerifyDTO}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthVerifyTfaSmsOtpLoginToken(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthVerifyTfaSmsOtpLoginToken>>, TError, {data: OtpVerifyDTO}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Verify Tfa Email Otp Login token
 */
export const utxAuthVerifyTfaEmailOtpLoginToken = (
    otpVerifyDTO: OtpVerifyDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/tfa-email-otp-login`,
      otpVerifyDTO,options
    );
  }



    export type UtxAuthVerifyTfaEmailOtpLoginTokenMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthVerifyTfaEmailOtpLoginToken>>>
    export type UtxAuthVerifyTfaEmailOtpLoginTokenMutationBody = OtpVerifyDTO
    export type UtxAuthVerifyTfaEmailOtpLoginTokenMutationError = AxiosError<unknown>

    export const useUtxAuthVerifyTfaEmailOtpLoginToken = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthVerifyTfaEmailOtpLoginToken>>, TError,{data: OtpVerifyDTO}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthVerifyTfaEmailOtpLoginToken>>, {data: OtpVerifyDTO}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthVerifyTfaEmailOtpLoginToken(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthVerifyTfaEmailOtpLoginToken>>, TError, {data: OtpVerifyDTO}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Verify OTP token
 */
export const utxAuthVerifyEmail = (
    otpVerifyDTO: OtpVerifyDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/verify-email`,
      otpVerifyDTO,options
    );
  }



    export type UtxAuthVerifyEmailMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthVerifyEmail>>>
    export type UtxAuthVerifyEmailMutationBody = OtpVerifyDTO
    export type UtxAuthVerifyEmailMutationError = AxiosError<unknown>

    export const useUtxAuthVerifyEmail = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthVerifyEmail>>, TError,{data: OtpVerifyDTO}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthVerifyEmail>>, {data: OtpVerifyDTO}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthVerifyEmail(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthVerifyEmail>>, TError, {data: OtpVerifyDTO}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Obtain OTP token
 */
export const utxAuthObtainOTP = (
    obtainOtpRequest: ObtainOtpRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ObtainOTPResponse>> => {
    return axios.post(
      `/auth/otp`,
      obtainOtpRequest,options
    );
  }



    export type UtxAuthObtainOTPMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthObtainOTP>>>
    export type UtxAuthObtainOTPMutationBody = ObtainOtpRequest
    export type UtxAuthObtainOTPMutationError = AxiosError<unknown>

    export const useUtxAuthObtainOTP = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthObtainOTP>>, TError,{data: ObtainOtpRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthObtainOTP>>, {data: ObtainOtpRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthObtainOTP(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthObtainOTP>>, TError, {data: ObtainOtpRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Hello endpoint
 */
export const utxAuthHello = (
    helloRequest: HelloRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/hello`,
      helloRequest,options
    );
  }



    export type UtxAuthHelloMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthHello>>>
    export type UtxAuthHelloMutationBody = HelloRequest
    export type UtxAuthHelloMutationError = AxiosError<unknown>

    export const useUtxAuthHello = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthHello>>, TError,{data: HelloRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthHello>>, {data: HelloRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthHello(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthHello>>, TError, {data: HelloRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * for email verification
 */
export const utxAuthMigrationFromGoogleLogin = (
    migrateRequest: MigrateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/migrate`,
      migrateRequest,options
    );
  }



    export type UtxAuthMigrationFromGoogleLoginMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthMigrationFromGoogleLogin>>>
    export type UtxAuthMigrationFromGoogleLoginMutationBody = MigrateRequest
    export type UtxAuthMigrationFromGoogleLoginMutationError = AxiosError<unknown>

    export const useUtxAuthMigrationFromGoogleLogin = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthMigrationFromGoogleLogin>>, TError,{data: MigrateRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthMigrationFromGoogleLogin>>, {data: MigrateRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxAuthMigrationFromGoogleLogin(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthMigrationFromGoogleLogin>>, TError, {data: MigrateRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxAuthLogout = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/logout`,undefined,options
    );
  }



    export type UtxAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthLogout>>>
    
    export type UtxAuthLogoutMutationError = AxiosError<unknown>

    export const useUtxAuthLogout = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthLogout>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthLogout>>, TVariables> = () => {
          

          return  utxAuthLogout(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthLogout>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get user's TFA sms code
 */
export const utxAuthRequestTfaSmsToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/request-tfa-sms-token`,undefined,options
    );
  }



    export type UtxAuthRequestTfaSmsTokenMutationResult = NonNullable<Awaited<ReturnType<typeof utxAuthRequestTfaSmsToken>>>
    
    export type UtxAuthRequestTfaSmsTokenMutationError = AxiosError<unknown>

    export const useUtxAuthRequestTfaSmsToken = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxAuthRequestTfaSmsToken>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxAuthRequestTfaSmsToken>>, TVariables> = () => {
          

          return  utxAuthRequestTfaSmsToken(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxAuthRequestTfaSmsToken>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    export const utxExternalAuthLogin = (
    externalLoginRequest: ExternalLoginRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ExternalLoginResponse>> => {
    return axios.post(
      `/auth/external/login`,
      externalLoginRequest,options
    );
  }



    export type UtxExternalAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof utxExternalAuthLogin>>>
    export type UtxExternalAuthLoginMutationBody = ExternalLoginRequest
    export type UtxExternalAuthLoginMutationError = AxiosError<unknown>

    export const useUtxExternalAuthLogin = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxExternalAuthLogin>>, TError,{data: ExternalLoginRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxExternalAuthLogin>>, {data: ExternalLoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxExternalAuthLogin(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxExternalAuthLogin>>, TError, {data: ExternalLoginRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxExternalAuthSignup = (
    externalSignupRequest: ExternalSignupRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ExternalSignupResponse>> => {
    return axios.post(
      `/auth/external/signup`,
      externalSignupRequest,options
    );
  }



    export type UtxExternalAuthSignupMutationResult = NonNullable<Awaited<ReturnType<typeof utxExternalAuthSignup>>>
    export type UtxExternalAuthSignupMutationBody = ExternalSignupRequest
    export type UtxExternalAuthSignupMutationError = AxiosError<unknown>

    export const useUtxExternalAuthSignup = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxExternalAuthSignup>>, TError,{data: ExternalSignupRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxExternalAuthSignup>>, {data: ExternalSignupRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxExternalAuthSignup(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxExternalAuthSignup>>, TError, {data: ExternalSignupRequest}, TContext>(mutationFn, mutationOptions)
    }
    